import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import { AccountBalance, BusinessCenter } from '@material-ui/icons';
import { toCurrency } from 'utils/helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    fontWeight: 700,
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
    height: 56,
    width: 56,
  },
  icon: {
    height: 32,
    width: 32,
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  differenceIcon: {
    color: theme.palette.success.dark,
  },
  differenceValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1),
  },
}));

export const PropertiesView = ({
  className,
  propertiesDetail = { count: 0, totalAmount: 0 },
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              PROPERTIES OVERVIEW
            </Typography>
            <Typography variant="h3">
              {toCurrency(propertiesDetail?.totalAmount)}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <AccountBalance className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <div className={classes.difference}>
          <BusinessCenter className={classes.differenceIcon} />
          <Typography className={classes.differenceValue} variant="body2">
            {propertiesDetail?.count} p
          </Typography>
          <Typography className={classes.caption} variant="caption">
            View details
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};
